/* eslint-disable functional/prefer-readonly-type */
import React, { useEffect, useState } from 'react';
import { Autocomplete, FormControl, TextField } from '@mui/material';
import { useLang } from '~/hooks/useLang';
import { useHookstate } from '@hookstate/core';
import { getCities } from '~/features/City/services';
import { StatusResponse } from './interfaces';
import { getStatus } from './services';



interface StatusProps {
    readonly onStatusChange: (value: number[]) => void;
    readonly statusId?: readonly number[];
    readonly disabled?: boolean
}

export default function FilterAutocompleteMultipleStatus({ onStatusChange, statusId, disabled }: StatusProps) {
    const { translate } = useLang();
    const [options, setOptions] = useState<readonly StatusResponse[]>([]);
    const [value, setValue] = useState<StatusResponse[] | undefined>([]);
    const loading = useHookstate(false);

    useEffect(() => {
        getStatus().then(status => {
          setOptions(status)
        })
      }, [])

    useEffect(() => {
        if (!statusId?.length) {
            setValue([])
        }
    }, [statusId?.length])

    return (
        <FormControl fullWidth size='small' >
            <Autocomplete
                filterSelectedOptions
                disableCloseOnSelect
                limitTags={2}
                sx={{ height: 1 }}
                ListboxProps={{ style: { maxHeight: '15rem' } }}
                id='filter-multiple-status'
                multiple
                options={options}
                value={value}
                disabled={disabled}
                noOptionsText={translate('No options')}
                clearText={translate('Clear')}
                size='small'
                loading={loading.get()}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                getOptionLabel={(option) => option.name ?? ''}
                onChange={(_, status) => {
                    setValue(status)
                    onStatusChange(status.map(item => item.id) ?? [])
                }}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label={translate('Status')}
                    />
                )}
            />
        </FormControl>
    )
}